<template>
    <NavbarMain />

    <PresentationSection v-if="currentLanguage === 'translated'" :photo="first_section_image_translated" :title="first_section_title_translated"
        :content="first_section_content_translated" />
    <PresentationSection v-else :photo="first_section_image_en" :title="first_section_title_en"
        :content="first_section_content_en" />

    <GeneralContactForm />

    <div class="columns-4-section">
        <PhotoCardsHeader v-if="currentLanguage === 'translated'" :section_title="third_section_title_translated"
            :section_content="third_section_content_translated" />
        <PhotoCardsHeader v-else :section_title="third_section_title_en" :section_content="third_section_content_en" />

        <PhotoCards v-if="currentLanguage === 'translated'" :section_image="third_section_box_image_translated"
            :button_title="third_section_box_title_translated" :button_text="third_section_box_content_translated"
            :button_link="third_section_box_link_translated" />
        <PhotoCards v-else :section_image="third_section_box_image_en" :button_title="third_section_box_title_en"
            :button_text="third_section_box_content_en" :button_link="third_section_box_link_en"/>
    </div>
    
    <FooterPage />
</template>

<script>
import axios from 'axios';

import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import PresentationSection from '@/components/PresentationSection.vue';
import GeneralContactForm from '@/components/GeneralContactForm.vue';
import PhotoCards from '@/components/PhotoCards.vue';
import PhotoCardsHeader from '@/components/PhotoCardsHeader.vue';

export default {
    components: {
        PresentationSection,
        NavbarMain,
        FooterPage,
        GeneralContactForm,
        PhotoCards,
        PhotoCardsHeader
    },
    data() {
        return {
            contactUsData: {
                items_translated: [{ first_section_image: '', first_section_title: '', first_section_content: '', second_section_title: '', second_section_content: '', third_section_title: '', third_section_content: '', third_section_box_image: '', third_section_box_title: '', third_section_box_content: '', third_section_box_link: '', forth_section_title: '', forth_section_content: '', fifth_section_title: '', fifth_section_content: '' }],
                items_en: [{ first_section_image: '', first_section_title: '', first_section_content: '', second_section_title: '', second_section_content: '', third_section_title: '', third_section_content: '', third_section_box_image: '', third_section_box_title: '', third_section_box_content: '', third_section_box_link: '', forth_section_title: '', forth_section_content: '', fifth_section_title: '', fifth_section_content: '' }]
            },

            first_section_image_translated: '',
            first_section_title_translated: '',
            first_section_content_translated: '',
            second_section_title_translated: '',
            second_section_content_translated: '',
            third_section_title_translated: '',
            third_section_content_translated: '',
            third_section_box_image_translated: '',
            third_section_box_title_translated: '',
            third_section_box_content_translated: '',
            third_section_box_link_translated: '',
            fourth_section_title_translated: '',
            fourth_section_content_translated: '',
            fifth_section_title_translated: '',
            fifth_section_content_translated: '',

            first_section_image_en: '',
            first_section_title_en: '',
            first_section_content_en: '',
            second_section_title_en: '',
            second_section_content_en: '',
            third_section_title_en: '',
            third_section_content_en: '',
            third_section_box_image_en: '',
            third_section_box_title_en: '',
            third_section_box_content_en: '',
            third_section_box_link_en: '',
            fourth_section_title_en: '',
            fourth_section_content_en: '',
            fifth_section_title_en: '',
            fifth_section_content_en: '',
        }
    },
    computed: {
        currentLanguage() {
            return this.$store.getters.getCurrentLanguage;
        },
    },
    created() {
        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/contact-us-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.contactUsData = response.data || { items_translated: [], items_en: [] };
                console.log(this.contactUsData)
                if (this.contactUsData.items_translated[0].active === true) {
                    this.first_section_title_translated = this.contactUsData.items_translated[0].first_section_title;
                    this.first_section_content_translated = this.contactUsData.items_translated[0].first_section_content;
                    this.first_section_image_translated = API_URL + this.contactUsData.items_translated[0].first_section_image;
                    this.second_section_title_translated = this.contactUsData.items_translated[0].second_section_title;
                    this.second_section_content_translated = this.contactUsData.items_translated[0].second_section_content;
                    this.third_section_title_translated = this.contactUsData.items_translated[0].third_section_title;
                    this.third_section_content_translated = this.contactUsData.items_translated[0].third_section_content;
                    this.third_section_box_image_translated = API_URL + this.contactUsData.items_translated[0].third_section_box_image;
                    this.third_section_box_title_translated = this.contactUsData.items_translated[0].third_section_box_title;
                    this.third_section_box_content_translated = this.contactUsData.items_translated[0].third_section_box_content;
                    this.third_section_box_link_translated = this.contactUsData.items_translated[0].third_section_box_link;
                    this.fourth_section_title_translated = this.contactUsData.items_translated[0].forth_section_title;
                    this.fourth_section_content_translated = this.contactUsData.items_translated[0].forth_section_content;
                    this.fifth_section_title_translated = this.contactUsData.items_translated[0].fifth_section_title;
                    this.fifth_section_content_translated = this.contactUsData.items_translated[0].fifth_section_content;
                }
                console.log(this.first_section_image_translated)

                if (this.contactUsData.items_en[0].active === true) {
                    this.first_section_title_en = this.contactUsData.items_en[0].first_section_title;
                    this.first_section_content_en = this.contactUsData.items_en[0].first_section_content;
                    this.first_section_image_en = API_URL + this.contactUsData.items_en[0].first_section_image;
                    this.second_section_title_en = this.contactUsData.items_en[0].second_section_title;
                    this.second_section_content_en = this.contactUsData.items_en[0].second_section_content;
                    this.third_section_title_en = this.contactUsData.items_en[0].third_section_title;
                    this.third_section_content_en = this.contactUsData.items_en[0].third_section_content;
                    this.third_section_box_image_en = API_URL + this.contactUsData.items_en[0].third_section_box_image;
                    this.third_section_box_title_en = this.contactUsData.items_en[0].third_section_box_title;
                    this.third_section_box_content_en = this.contactUsData.items_en[0].third_section_box_content;
                    this.third_section_box_link_en = this.contactUsData.items_en[0].third_section_box_link;
                    this.fourth_section_title_en = this.contactUsData.items_en[0].forth_section_title;
                    this.fourth_section_content_en = this.contactUsData.items_en[0].forth_section_content;
                    this.fifth_section_title_en = this.contactUsData.items_en[0].fifth_section_title;
                    this.fifth_section_content_en = this.contactUsData.items_en[0].fifth_section_content;
                }
            })
            .catch(error => {
                console.error('Error fetching Contact US data:', error);
            });


        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    }
}

</script>

<style>
@import '@/css/main.css';

.columns-6-section {
    margin-left: 5%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: center;
    /* Center the columns horizontally */
    align-items: center;
    gap: 10px;
    padding: auto;
}

@media all and (max-width: 850px) {
    .columns-6-section {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }
}

.columns-4-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    /* Center the columns horizontally */
    align-items: center;
    gap: 10px;
    padding: auto;
}

@media all and (max-width: 850px) {
    .columns-4-section {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }
}
</style>